import React, { useEffect, useState } from 'react';
import '../../App.css';
import { logout, setUserId } from '../../features/auth/authSlice'
import { userLogout } from '../../features/auth/authActions'
import { selectGamesStatus } from '../../features/player/gameStatusSlice'
import { fetchUser } from '../../features/user/userSlice'
import { useNavigate } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { IGameStatus } from '../../interfaces';
import { GameStatus } from '../../Classes1';
import {parseJwt} from "../../helpers/helperFunctions";

interface PlayerHeaderProps {
    showGame: string;
    intervalHandler: (command: string, gameId: string, inGame: boolean) => void;
}

const PlayerHeader: React.FC<PlayerHeaderProps> = ({ showGame, intervalHandler }) => {
    
    const { accessToken } = useAppSelector((state: any) => state.auth)

    let currentGameStatus: IGameStatus = useAppSelector(selectGamesStatus)[0];
    if (currentGameStatus === undefined) {
        currentGameStatus = new GameStatus();
    }
    
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    let [loggedIn, setLoggedIn] = useState<boolean>(false);
    let [userInfo, setUserInfo] = useState<any>({});

    useEffect(() => {
        const getUserInfo = async (id: string) => {
            let user: any = await dispatch(fetchUser(id))
            if (user.payload === undefined || user.error !== undefined) {
                dispatch(logout())
                setLoggedIn(false)
            } else {
                setUserInfo(user.payload)
                intervalHandler("start", currentGameStatus.gameId, false)
                dispatch(setUserId());
                setLoggedIn(true)
            }
        }
        if (accessToken) {
            let parsedJWT = parseJwt(accessToken)
            getUserInfo(parsedJWT.id)
            dispatch(setUserId());
        } else {
          setLoggedIn(false)
          intervalHandler("stop", "", false)
          navigate('/login')
        }
      }, [navigate, accessToken, dispatch, setLoggedIn]) // eslint-disable-line react-hooks/exhaustive-deps

    const clickLogout = async (ev: React.MouseEvent<HTMLElement>) => {
        await dispatch(userLogout())
        dispatch(logout())
        intervalHandler("stop", "", false)
        setLoggedIn(false)
    }

    return (
            showGame === 'show-game' ? 
            <div className="game-header">
                <div className="game-scenario-title">{currentGameStatus.scenarioName} ({currentGameStatus.name}) -- Turn {currentGameStatus.currentTurn}</div>
                <div className='game-header-status'>
                        <div className="header-info">
                            <div className="header-icon">
                                <img src="img/person.svg" alt="person" className="header-info-person" />
                            </div>
                            <div className="header-info-list">
                                
                                {loggedIn ? 
                                    <div className="header-info-item header-username">
                                        <img src="img/person.svg" className="header-info-icon" alt="user" />
                                        <div className="header-info-id">{userInfo.email}</div>
                                    </div>
                                : ''}

                                <div className="header-info-item" onClick={() => window.location.replace('/player') }>
                                    <img src="img/chevron-right-grey.svg" className="header-info-icon" alt="logout" />
                                    <button className='logout-link'>
                                        Return to Scenarios
                                    </button>
                                </div>
                                
                                <div className="header-info-item" onClick={clickLogout}>
                                    <img src="img/logout.svg" className="header-info-icon" alt="logout" />
                                    <button className='logout-link'>
                                        Logout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             : 
            <div className={`player-header`}>
                <img src="img/txp-player-logo.svg" className="player-logo" alt="" />
                <div className='header-status'>
                    <div className="header-info">
                        <div className="header-icon">
                            <img src="img/person.svg" alt="person" className="header-info-person" />
                        </div>
                        <div className="header-info-list">
                            
                            {loggedIn ? 
                                <div className="header-info-item header-username">
                                    <img src="img/person.svg" className="header-info-icon" alt="user" />
                                    <div className="header-info-id">{userInfo.email}</div>
                                </div>
                            : ''}
                            
                            <div className="header-info-item" onClick={clickLogout}>
                                <img src="img/logout.svg" className="header-info-icon" alt="logout" />
                                <button className='logout-link'>
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default PlayerHeader